/**
 * Telegram Login Widget users have no real email, so the backend mints a
 * synthetic placeholder on the Supabase auth row of the form
 * `tg_<externalId>@telegram.cros-air.invalid` (`.invalid` per RFC 6761 so it
 * can never collide with a real address). The local `users.email` column
 * stays NULL for those accounts — that is the source of truth.
 *
 * `authData.email` is sourced from the Supabase session, which carries the
 * synthetic value, so any UI that displays the email needs to guard against
 * it. Backend constant lives in `services/telegram/auth.ts:syntheticTelegramEmail`.
 */
const SYNTHETIC_TELEGRAM_EMAIL_DOMAIN = "telegram.cros-air.invalid";

export function isSyntheticTelegramEmail(email: string | null | undefined): boolean {
  if (!email) return false;
  return email.endsWith(`@${SYNTHETIC_TELEGRAM_EMAIL_DOMAIN}`);
}
